export { initYogaBooking, autoInitYogaBooking } from './init';
export type {
  YogaBookingConfig,
  YogaBookingHandle,
  YogaBookingControls,
} from './types';

import { autoInitYogaBooking } from './init';

autoInitYogaBooking();
